export default function GlobalPresence() {
  return (
    <section id="about" className="relative bg-primary-900 text-background-50 py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0 bg-dot-pattern opacity-20"></div>
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-accent-500/10 blur-3xl"></div>
      <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full bg-primary-500/20 blur-3xl"></div>

      <div className="relative max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/20 text-background-100 text-xs font-semibold uppercase tracking-wider">
              <i className="ri-earth-line"></i>
              Global presence
            </div>
            <h4 className="mt-5 font-heading font-bold text-3xl md:text-5xl leading-tight">
              <a href="#about" className="hover:text-accent-300 transition-colors cursor-pointer">
                Headquartered in Armenia. Delivering across two continents.
              </a>
            </h4>
            <p className="mt-5 text-background-200 text-base md:text-lg leading-relaxed">
              We combine India's engineering depth with Armenia's European proximity and
              regulatory access. That means follow-the-sun delivery, strong data
              sovereignty options, and a partner that speaks your business hours.
            </p>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="p-5 rounded-lg bg-background-50/5 border border-background-50/10 backdrop-blur">
                <div className="flex items-center gap-3 mb-2">
                  <span className="w-8 h-8 flex items-center justify-center rounded-md bg-accent-500 text-background-50">
                    <i className="ri-map-pin-2-line"></i>
                  </span>
                  <div className="font-heading font-semibold text-lg">Yerevan, Armenia</div>
                </div>
                <div className="text-xs text-background-300 uppercase tracking-widest mb-1">Global HQ</div>
                <p className="text-sm text-background-200">Product engineering, RWA compliance, EU-facing sales.</p>
              </div>
              <div className="p-5 rounded-lg bg-background-50/5 border border-background-50/10 backdrop-blur">
                <div className="flex items-center gap-3 mb-2">
                  <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-400 text-background-50">
                    <i className="ri-map-pin-2-line"></i>
                  </span>
                  <div className="font-heading font-semibold text-lg">Mohali, Chandigarh, India</div>
                </div>
                <div className="text-xs text-background-300 uppercase tracking-widest mb-1">Delivery Centre</div>
                <p className="text-sm text-background-200">Custom software squads, GDB data centre, 24×7 NOC.</p>
              </div>
            </div>

            <div className="mt-8 flex flex-wrap gap-6 text-sm text-background-200">
              <div className="flex items-center gap-2"><i className="ri-time-line text-accent-400"></i> Follow-the-sun coverage</div>
              <div className="flex items-center gap-2"><i className="ri-shield-check-line text-accent-400"></i> ISO 27001 aligned</div>
              <div className="flex items-center gap-2"><i className="ri-lock-2-line text-accent-400"></i> GDPR-ready</div>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-lg overflow-hidden border border-background-50/20 bg-background-50/5 backdrop-blur">
              <img
                src="https://readdy.ai/api/search-image?query=Highly%20detailed%20realistic%20world%20map%20on%20a%20dark%20navy%20background%20with%20Armenia%20and%20India%20clearly%20highlighted%20in%20bright%20warm%20orange%20glow%2C%20glowing%20connection%20arcs%20between%20Yerevan%20and%20Chandigarh%2C%20other%20continents%20in%20subtle%20light%20gray%20with%20visible%20country%20borders%2C%20modern%20corporate%20infographic%20style%20with%20sharp%20readable%20text%20labels%20for%20city%20names%2C%20high%20contrast%20professional%20geographic%20visualization%2C%20no%20abstract%20distortion%20ultra%20clear%20and%20visible%20map%20details%20suitable%20for%20business%20presentation&width=1200&height=1000&seq=global-map-v2&orientation=squarish&nocache=true"
                alt="Global presence map — Armenia and India"
                className="w-full h-auto object-cover object-top"
              />
            </div>

            {/* Floating badges */}
            <div className="absolute top-6 -left-4 md:-left-6 flex items-center gap-3 bg-background-50 text-foreground-900 px-4 py-3 rounded-md">
              <div className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-team-line"></i>
              </div>
              <div className="text-xs">
                <div className="font-semibold">120+ engineers</div>
                <div className="text-foreground-500">Two centres</div>
              </div>
            </div>
            <div className="absolute bottom-6 -right-4 md:-right-6 flex items-center gap-3 bg-accent-500 text-background-50 px-4 py-3 rounded-md">
              <div className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50/20">
                <i className="ri-medal-2-line"></i>
              </div>
              <div className="text-xs">
                <div className="font-semibold">15+ years</div>
                <div className="text-background-100">Enterprise delivery</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}